import { Box, IconButton, Tooltip, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { RatingTypography, StatusChip } from "components";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export const ReviewHeader = ({
  review,
  isOwnReview,
  isVerifiedUser,
  canEdit,
  canDelete,
  onStartEdit,
  onDelete,
  showUserReviewsOnly = false,
}) => (
  <Box display="flex" justifyContent="space-between" alignItems="flex-start" width="100%">
    <Box>
      <Box display="flex" gap={0.5}>
        {showUserReviewsOnly ? (
          <Box>
            <Link
              component={RouterLink}
              to={
                review.dealId
                  ? `/restaurant/${review.restaurantId}/deal/${review.dealId}`
                  : `/restaurant/${review.restaurantId}`
              }
              sx={{ textDecoration: "none", color: "inherit", "&:hover": { textDecoration: "underline", color: "primary.main" } }}
            >
              <Typography variant="body2" fontWeight="normal">
                {review.dealTitle || review.restaurantName}
              </Typography>
            </Link>
            {review.dealId && review.restaurantName && (
              <Link
                component={RouterLink}
                to={`/restaurant/${review.restaurantId}`}
                sx={{ textDecoration: "none", color: "text.secondary", "&:hover": { textDecoration: "underline", color: "primary.main" } }}
              >
                <Typography variant="caption" color="text.secondary">
                  {review.restaurantName}
                </Typography>
              </Link>
            )}
          </Box>
        ) : (
          <Link
            component={RouterLink}
            to="/profile/reviews"
            sx={{ textDecoration: "none", color: "inherit", "&:hover": { textDecoration: "underline", color: "primary.main" } }}
          >
            <Typography variant="subtitle1" fontWeight={isOwnReview ? "bold" : "normal"}>
              {review.name}
            </Typography>
          </Link>
        )}
        {isVerifiedUser && (
          <Tooltip title="Verified User">
            <VerifiedUserIcon fontSize="inherit" sx={{ color: "text.secondary" }} />
          </Tooltip>
        )}
        {isOwnReview &&
          (showUserReviewsOnly ? (
            <StatusChip status={review.status} />
          ) : (
            review.status !== "approved" && <StatusChip status={review.status} />
          ))}
      </Box>
      <RatingTypography rating={review.rating} />
      <Typography variant="caption" color="text.secondary">
        {dayjs(review.createdDate).fromNow()}
        {review.status === "approved" &&
          review.editedDate &&
          review.editedDate !== review.createdDate && <span> • edited</span>}
      </Typography>
    </Box>

    {isOwnReview && (
      <Box display="flex" gap={0.5} flexShrink={0}>
        {canEdit && (review.status === "approved" || review.status === "pendingCreate") && (
          <IconButton
            size="small"
            onClick={() => onStartEdit(review)}
            disabled={review.status === "pendingDelete"}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        )}
        {canDelete && review.status !== "pendingEdit" && (
          <IconButton
            size="small"
            onClick={() => onDelete(review.id)}
            disabled={review.status === "pendingDelete"}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    )}
  </Box>
);